import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {RatingsErrorsFactory} from '../Errors/factory.js'
import {RatingsValueObjectsFactory} from '../ValueObjects/factory.js'
import {HttpRatingsRepository} from './HttpRatingsRepository.js'

export class RatingsRepositoriesFactory {
  static httpRatingsRepository = ({config}) =>
    new HttpRatingsRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      cancelTradeRatingsError: RatingsErrorsFactory.cancelTradeRatingsError,
      statusTradeRatingsValueObjectFactory: RatingsValueObjectsFactory.statusTradeRatingsValueObject
    })
}
